import BaseEnumType from "../../common/base-enum-type";
const FieldLength = Object.freeze({
    OptionOne: new BaseEnumType(40, "40"),
    OptionTwo: new BaseEnumType(50, "50"),
    OptionThree: new BaseEnumType(60, "60"),
    OptionFour: new BaseEnumType(70, "70"),
    OptionFive: new BaseEnumType(80, "80"),
    OptionSix: new BaseEnumType(90, "90"),
    OptionSeven: new BaseEnumType(100, "100"),
    OptionEight: new BaseEnumType(110, "110")
});

export default FieldLength;
